<template>
    <footer>
        <div class="footer--contact">
            <p>14 Rue Esther Cuvier</p>
            <p>F-93260 LES LILAS</p>
            <p>Tél: +33 (0)1 48 97 20 20</p>
            <p>Fax: +33 (0)1 48 97 20 07</p>
            <p>E-mail: contact@ablgroupe.com</p>
            <!--p Développement : Théo Bourgoin-->
        </div>
        <h3>&copy; ABL Groupe - 2021</h3>
    </footer>
    <!--<script src="#{assetPath('jquery-3.1.1.js')}"></script>-->
    <!--<script src="#{assetPath('dropdown.js')}"></script>-->
    <!--<script src="#{assetPath('flickity.pkgd.min.js')}"></script>-->
    <!--<script src="#{assetPath('unveil.js')}"></script>-->
    <!--<script src="#{assetPath('carousel.js')}"></script>-->
</template>

<script>

    export default {
        name: "AppFooter"
    }
</script>

<style scoped lang="scss">
    footer {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        align-content: center;
        padding: 10px 0;
        background: #ffffff;
        color: $dark;
        box-shadow: 0 3px 20px rgba(0, 0, 0, 0.27);

        & .footer--contact {
            padding: 0 20px;
            text-align: right;
            border-right: 1px solid #E1E6FA;
            margin-right:  20px;
        }
    }
</style>